import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { CtAuthenticationGuard } from '@ctsolution/ct-authentication';
import { RESET_PASSWORD_PATH } from './core/services/password-reset.service';
import { environment } from '../environments/environment';

const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'registrazione',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'account',
    canActivate: [CtAuthenticationGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'prenotazioni',
        loadComponent: () => import('./pages/profile/bookings-list/bookings-list.component').then(m => m.BookingsListComponent),
      },
      {
        path: 'modifica-profilo',
        loadComponent: () => import('./pages/profile-edit/profile-edit.component').then(m => m.ProfileEditComponent),
      },
      {
        path: 'faq',
        loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent),
      },
      {
        path: 'portafoglio',
        loadComponent: () => import('./pages/profile/wallet/wallet.component').then(m => m.WalletComponent),
      },
    ],
  },
  {
    path: 'stazioni/:stationId/configura',
    loadComponent: () => import('./pages/booking-configure/booking-configure.component').then(m => m.BookingConfigureComponent),
  },
  {
    path: 'stazioni/risultati',
    loadComponent: () => import('./pages/station-results/station-results.component').then(m => m.StationResultsComponent),
  },
  {
    path: 'prenotazione/pagamento',
    loadComponent: () => import('./pages/payment/payment.component').then(m => m.PaymentComponent),
  },
  {
    path: 'prenotazione/conferma',
    loadComponent: () => import('./pages/booking-confirmed/booking-confirmed.component').then(m => m.BookingConfirmedComponent),
  },
  {
    path: 'payment/result',
    loadComponent: () => import('./pages/payment-result/payment-result.component').then(m => m.PaymentResultComponent),
  },
  {
    path: 'conferma-email',
    loadComponent: () => import('./pages/email-confirm/email-confirm.component').then(m => m.EmailConfirmComponent),
  },
  {
    path: 'recupera-password',
    loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  {
    // I link di reset gia' spediti puntano a un path inesistente: la libreria CT accodava
    // /ct-authentication/reset-password al callback. Un URL sconosciuto che porta token e indirizzo
    // e' un link di reset, non un errore di digitazione: va alla pagina di reset, non in home.
    path: '**',
    redirectTo: ({ queryParams }) =>
      queryParams['t'] && queryParams['e']
        ? inject(Router).createUrlTree([RESET_PASSWORD_PATH], { queryParams })
        : '',
  },
];

// Finche' l'app non e' pubblica, ogni URL mostra la pagina "lavori in corso"
const workInProgressRoutes: Routes = [
  {
    path: '**',
    loadComponent: () => import('./pages/work-in-progress/work-in-progress.component').then(m => m.WorkInProgressComponent),
  },
];

export const routes: Routes = environment.workInProgress ? workInProgressRoutes : appRoutes;
